export class Emitter<T extends Record<string, unknown>> {
  private listeners: { [K in keyof T]?: Array<(arg: T[K]) => void> } = {};

  on<K extends keyof T>(event: K, cb: (arg: T[K]) => void): () => void {
    (this.listeners[event] ??= []).push(cb);
    return () => {
      const arr = this.listeners[event];
      if (!arr) return;
      const i = arr.indexOf(cb);
      if (i >= 0) arr.splice(i, 1);
    };
  }

  emit<K extends keyof T>(event: K, arg: T[K]): void {
    const arr = this.listeners[event];
    if (!arr) return;
    for (const cb of arr.slice()) cb(arg);
  }
}
